import classNames from 'classnames'

export default function Footer({ className }) {
  const impressumLink = "https://www.edgeecom.de/legal/imprint";
  const datenschutzLink = "https://www.edgeecom.de/legal/privacy-policy";
  const agbLink = "https://www.edgeecom.de/legal/terms-of-service";

  return (
    <div className={classNames('left-0 right-0 bottom-1 z-10 py-2 bg-background pl-20', className)}>
      <p className="text-textFooter text-center text-xs">
        2025 EDGE SOLUTIONS - All rights reserved |
        <a
          className=" ml-1 mr-1"
          href={impressumLink}
          target="_blank"
          rel="noreferrer"
        >
          Impressum
        </a>
        -
        <a
          className=" ml-1 mr-1"
          href={datenschutzLink}
          target="_blank"
          rel="noreferrer"
        >
          Datenschutz
        </a>
        -
        <a className=" ml-1" href={agbLink} target="_blank" rel="noreferrer">
          Allgemeine Geschäftsbedingungen
        </a>
      </p>
    </div>
  );
};
